import { JobFullType, JobPartialType } from '.';

export type JobType = JobFullType | JobPartialType;

export function isJobFullType(job: JobType): job is JobFullType {
    return (job as JobFullType).privateDescription !== undefined;
}
